class QuickShipServiceClass {
  formLabelQueBatchFromPusherMessage(pusherMessage, isComplete) {
    return {
      batchId: pusherMessage.status?.BatchID,
      batchNumber: pusherMessage.status?.BatchNumber,
      completed: pusherMessage.status?.Completed,
      createDate: pusherMessage.status?.Created,
      errors: pusherMessage.status?.Errors,
      printDateUTC: pusherMessage.status?.PrintDate,
      processDate: pusherMessage.status?.ProcessDateUTC,
      shipDate: pusherMessage.status?.ShipDate,
      statusId: pusherMessage.status?.StatusID,
      total: pusherMessage.status?.Total,
      userId: pusherMessage.status?.UserID,
      warnings: pusherMessage.status?.Warnings,
      isComplete,
      shipFrom: pusherMessage.status?.Warehouse,
      warehouseId: pusherMessage.status?.WarehouseID,
      batchNotes: pusherMessage.status?.Notes,
      fillMethod: pusherMessage.status?.FillMethod,
    };
  }
}

export const QuickShipService = new QuickShipServiceClass();
